// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__vrFM9","spin":"spinner_spin__BOZSj"};